import styled from "styled-components";
import { Chip, withTheme } from "@material-ui/core";

const StyledChip = styled(Chip)({
  "&&.MuiChip-root": {
    backgroundColor: "#24272A",
    color: "#fff",
    fontSize: "11px",
    padding: "6px 10px",
    height: "auto",
  },
  "& .MuiChip-label": {
    padding: 0,
  },
});

function ImovelChip(props: any) {
  return <StyledChip {...props} />;
}

export default withTheme(ImovelChip);
